module.exports = __webpack_public_path__ + "static/img/107.5aee544.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/210317/107.jpg
// module id = 7WM4
// module chunks = 0